// extracted by css-extract-rspack-plugin
export default {"container":"tfNWI8Pr8cz440OD"};